/**
 * Single owner for navigation / stage motion timing.
 * CSS reads --motion-* / --ease-* set by applyMotionVars().
 */
export const MOTION = {
  ms: {
    tap: 120,
    hover: 220,
    spring: 320,
    fade: 450,
    theater: 520,
    nav: 850,
    flight: 900,
    intro: 1200,
    introStagger: 188,
  },
  ease: {
    standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
    settle: 'cubic-bezier(0.33, 1, 0.68, 1)',
    linear: 'linear',
  },
}

const applyMotionVars = () => {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  Object.entries(MOTION.ms).forEach(([name, value]) => {
    root.style.setProperty(`--motion-${name}`, `${value}ms`)
  })
  Object.entries(MOTION.ease).forEach(([name, value]) => {
    root.style.setProperty(`--ease-${name}`, value)
  })
}

applyMotionVars()
